import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FieldDefinition} from '@shared/models/field-definition';
import {PagedResponseRow} from '@shared/models/paged-response-model';
import {DialogModel} from '@shared/models/dialog.model'
import {DialogService} from '@shared/services/dialog-service';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Subject} from 'rxjs';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    standalone: false,
    selector: 'particle-translation-download-action-cell-viewer',
  templateUrl: './translation-download-action-cell-viewer.component.html',
  styleUrls: ['./translation-download-action-cell-viewer.component.scss']
})

export class TranslationDownloadActionCellViewerComponent implements OnInit, OnDestroy, CellComponent {
  fieldDefinition: FieldDefinition;
  item: any;
  value: any;
  displayText: string;
  unsubscribe$ = new Subject<void>();

  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor(
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router,
              private queryStore: Store<IQueryState>) {
  }
  ngOnInit() {


      }

  onDownloadClick(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }

  onHyperLinkClick(action: string) {
    //console.log("Hssasass",this.item);
    //console.log("Hssasass",this.fieldDefinition);
     if ((this.item && !this.item.isReadOnly) || (this.fieldDefinition )) {
        this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition,action: {id: action}});
     }
  }

    // this.taxFormsService.downloadFormWithId(this.item.id);

  private emitDownloadFileEvent(fileId: any) {
    const payload = {
      item: this.item,
      fieldDefinition: this.fieldDefinition,
      action: 'Download',
      DownloadConfig: {
        formId: this.item.id,
        toolName: 'Forms',
        isForm: true,
        translateFrom: this.item.cells['Language'].value
      }
    };
    this.valueChanged.emit(payload);
  }
  ngOnDestroy(): void {
  }


}

